function precision(a) {
  if (!isFinite(a)) return 0;
  var e = 1,
    p = 0;
  while (Math.round(a * e) / e !== a) {
    e *= 10;
    p++;
  }
  return p;
}

function getMaxDecimalPlaces(a, b) {
  return Math.max(precision(a), precision(b));
}

export const getTotalMiles = ([from, to]) => {
  const parsedFrom = parseFloat(from);
  const parsedTo = parseFloat(to);
  if (isNaN(parsedFrom) || isNaN(parsedTo)) return "";

  // detemrmine decimal places for the final result
  const decimalPlaces = getMaxDecimalPlaces(parsedFrom, parsedTo);
  return Math.abs(parsedTo - parsedFrom).toFixed(decimalPlaces);
};



// WEBPACK FOOTER //
// ./src/components/Reports/utils/getTotalMiles.js